import fetchReports from './fetchReports';

export default [fetchReports];
